



























import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import auth from '@/auth'
import { XvOrdersResp_Order, XvOrdersReq_OrderType, InternalStatus } from '@/apiv3/index'
import XvOrder from './XvOrder.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

@Component({ components: { XvOrder, PulseLoader } })
export default class XvOrders extends Vue {
  public orders: XvOrdersResp_Order[] | null = null
  public loaded = false
  public InternalStatus = InternalStatus

  mounted (): void {
    auth.adminClient().XvOrders({ type: XvOrdersReq_OrderType.CURRENT }).then((resp) => {
      this.orders = resp.orders
    }).finally(() => {
      this.loaded = true
    })
  }

  public filter (status: InternalStatus): XvOrdersResp_Order[] {
    const orders: XvOrdersResp_Order[] = []

    if (!this.orders) {
      return orders
    }

    this.orders.forEach(val => {
      if (val.internalStatus === status) {
        orders.push(val)
      }
    })

    return orders
  }
}
